import axios from "axios";
import { API } from "./constants";

const baseUrl = API.BASE_URL
const baseUrlNameSelf = API.API_BASE_URL_SELF;
const baseUrlName = API.API_BASE_URL;

const axiosInstance = () => {

  const common_axios = axios.create({
    baseURL: baseUrlName
  });

  if (getToken()) {
    common_axios.defaults.headers.common['Authorization'] = "Bearer " + getToken();
  }
  // common_axios.defaults.headers.post['Content-Type'] = 'application/json';
  common_axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
  common_axios.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  common_axios.defaults.headers.common['Pragma'] = 'no-cache';
  common_axios.defaults.headers.common['Expires'] = '0';
  
  return common_axios;

}


const axiosInstanceSelf = () => {
  const common_axios_self = axios.create({
    baseURL: baseUrlNameSelf
  });

  if (getToken()) {
    common_axios_self.defaults.headers.common['Authorization'] = "Bearer " + getToken();
    
  }
  // common_axios.defaults.headers.post['Content-Type'] = 'application/json';
  common_axios_self.defaults.headers.common['Content-Type'] = 'multipart/form-data';
  common_axios_self.defaults.headers.common['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  common_axios_self.defaults.headers.common['Pragma'] = 'no-cache';
  common_axios_self.defaults.headers.common['Expires'] = '0';
  return common_axios_self;

}


function getToken() {
  // @ts-ignore
  let localData = localStorage.getItem("w_token");
  const token = localData ? JSON.parse(localStorage.getItem("w_token") || "") : '';

  if (token && token?.access_token !== '') {
    return token?.access_token;

  } else {
    return null;
  }
}

const AuthHeader = {
  axiosInstance,
  axiosInstanceSelf,
  baseUrlName,
  baseUrl
}

export default AuthHeader;
